import React from 'react';
import { Typography } from '@mui/material';
import { Box, styled } from '@mui/system';

export default function CompactStepper({ activeStep, steps }) {
  const total = steps.length;
  const current = steps[activeStep];
  const progress = total > 0 ? Math.round(((activeStep + 1) / total) * 100) : 0;

  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mb: 0.5 }}>
        {`Schritt ${activeStep + 1} von ${total}`}
      </Typography>
      <Typography variant="body2" sx={{ fontWeight: 500, mb: 1 }}>
        {current?.label}
      </Typography>
      <Track>
        <Fill sx={{ width: `${progress}%` }} />
      </Track>
    </Box>
  );
}

const Track = styled(Box)(({ theme }) => ({
  height: '4px',
  borderRadius: '2px',
  backgroundColor: theme.palette.divider,
  overflow: 'hidden',
}));

const Fill = styled(Box)(({ theme }) => ({
  height: '100%',
  borderRadius: '2px',
  backgroundColor: theme.vars?.palette?.primary?.main || theme.palette.primary.main,
  transition: 'width 0.3s ease',
}));
